// extracted by mini-css-extract-plugin
module.exports = {"resources":"f_7","sectionTitle":"f_8","sectionTitleResources":"f_9"};